import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import "./service1.css"
import { Link } from "react-router-dom";
import projectData from "../components/projectdata.js"

function Service3() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true); // Control fade animation
  const goodsProjects = projectData.filter(project => project["service-type"].includes("goods"));
  const images = goodsProjects.map(project => project.images[0]);
  const projectNames = goodsProjects.map(project => project["project-name"]);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade-out
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(true); // Fade-in new image
      }, 500); // 500ms fade-out before changing the image
    }, 5000); // Change image every 3s

    return () => clearInterval(interval);
  }, [images.length]);

    return (
      <div className="service1">

        <div className="service1-header">
          <h1>
          ผลิตและนำเข้าเครื่องครัวครบวงจร
          </h1>
          <ul>
            <li>ผลิตเครื่องครัวสแตนเลสแบบมาตรฐาน และตามความต้องการของลูกค้า ภายใต้ชื่อ <a href="https://shopee.co.th/nichdaso?entryPoint=ShopBySearch&searchKeyword=factoryoutletshop" target="_blank" rel="noopener noreferrer">‘Factory Outlet Shop’</a></li>
            <li>นำเข้าและจำหน่ายอุปกรณ์ทำอาหารครบวงจร</li>
          </ul>
        </div>

        { images.length !== 0 &&
        <div className="service-project-preview">
          <img src={images[currentIndex]} alt="" className={`fade ${fade ? "fade-in" : "fade-out"}`}/>
          <div className="banner-absolute-container">
              <p style={{fontStyle: 'italic', fontSize: '12px', fontWeight: '300'}} className="banner-italics">{currentIndex+1}/{images.length}</p>
              <p style={{paddingTop : '8px', fontSize: '14px'}} className="banner-project-name">{projectNames[currentIndex]}</p>
          </div>
        </div>
        }
        
        <div className="detail-section-1">
          <div>
          <h1>สินค้าหลากหลาย <br />
          สั่งง่ายพร้อมส่ง</h1>
          <p>มีสินค้าให้เลือกหลากหลาย ครอบคลุมทุกความต้องการ <br />
          ตั้งแต่ครัวขนาดเล็กจนถึงครัวอุตสาหกรรม <br />
          ติดต่อสะดวกให้คำแนะนำทุกขั้นตอน สต็อกพร้อมจัดส่ง <br />
          ได้รับสินค้ารวดเร็ว ไม่ต้องรอนาน ไม่ว่าจะต้องการสินค้า <br />
          สำเร็จรูปหรือสั่งผลิตตามแบบ เราพร้อมจัดให้</p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section1.png")} alt="" />
        </div>

        <div className="detail-section-2">
          <div>
          <h1>สินค้าคุณภาพ <br />
          ราคาเป็นมิตร</h1>
          <p>
          มุ่งมั่นคัดสรร สินค้าสเตนเลสคุณภาพสูง ที่ทั้ง ทนทาน <br />
          แข็งแรง และใช้งานได้จริง ในราคาที่ย่อมเยาและคุ้มค่า <br />
          ด้วยสแตนเลส 304 แข็งแรง ทนทาน ไม่ดูดซับกลิ่น  <br />
          ทดลองสินค้าทุกตัวก่อนจัดส่งทุกออเดอร์ <br />
          เราเชื่อว่า คุณภาพไม่จำเป็นต้องแพง  <br />
          และลูกค้าควรได้รับสินค้าที่ดีที่สุดในราคาที่เป็นธรรม
          </p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section2.png")} alt="" />
        </div>

        <div className="detail-section-3">
          <div>
          <h1>บริการทั่วถึง <br />
          ติดตั้งทั่วไทย</h1>
          <p>ให้บริการครอบคลุมทุกพื้นที่ รับประกันสินค้าจากร้าน <br />
          พร้อมจัดส่งสินค้าทั่วประเทศ ไม่ว่าคุณจะอยู่ที่ไหน <br />
          เราพร้อมส่งมอบสินค้าคุณภาพเยี่ยม <br />
          ให้ถึงมือคุณอย่างปลอดภัย</p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section3.png")} alt="" />
        </div>
        
        <div className="service3-link-container">
        <a href="https://shopee.co.th/nichdaso?entryPoint=ShopBySearch&searchKeyword=factoryoutletshop" target="_blank" rel="noopener noreferrer"><p>ดูสินค้าของเรา <FaArrowRight className="right-icon" /></p></a>
        <Link to="/contact"><p>ขอคำแนะนำจากผู้เชี่ยวชาญ <FaArrowRight className="right-icon" /></p></Link>
        </div>
          
        
        
      </div>
    );
  }
  
  export default Service3;
